import { defineModule } from '@berky/module-contract'

/**
 * Das Manifest ist die einzige Verbindung zwischen Modul und Shell.
 * Die Shell findet diese Datei selbst — sie muss nirgends eingetragen werden.
 */
export default defineModule({
  id: 'beispiel',
  title: 'Beispiel',
  description: 'Referenzmodul für neue Anwendungen: Liste, Detailseite und Formular.',
  icon: 'ClipboardList',
  order: 10,
  apiBasePath: '/api/beispiel',

  // Ein echtes Fachmodul hat hier in der Regel ein leeres Array — das heißt
  // „für alle angemeldeten Nutzer sichtbar“. Das Referenzmodul nicht: es hat
  // keinen fachlichen Zweck und gehört deshalb nicht in die Navigation jedes
  // Nutzers. Wer sich die Vorlage im laufenden Portal ansehen will, bekommt
  // eine der beiden Rollen in der Verwaltung zugewiesen; angemeldet hat sie
  // das Backend beim Start selbst (BeispielModule.Roles).
  //
  // Lokal ändert das nichts: der Mock-Nutzer hat '*' und sieht weiter alles.
  roles: ['beispiel.bearbeiter', 'beispiel.freigeber'],

  routes: () => import('./src/routes'),
  homeWidget: () => import('./src/home-widget'),
})
